import { Timer } from '../../../../timer/timer';

let vcTimer = null;
export const timerMap = new Map();

export const createVolumeControlTimer = ({ action, dispatch, sendToSessionId, settings, upfrontEnabled, delay }) => {
  const task = () => {
    dispatch(action(sendToSessionId, settings, upfrontEnabled));
    timerMap.delete(sendToSessionId);
  };
  const opts = { delay, task };
  vcTimer = Timer({ opts });
  vcTimer.start();
  timerMap.set(sendToSessionId, vcTimer);
};

export const vcTimersExist = () => timerMap.size > 0;

export const clearVcTimers = () => timerMap.clear();

export const resumeVcTimers = () => {
  if (vcTimersExist()) {
    timerMap.forEach(timer => {
      const { taskCalled } = timer.timerTaskCalled();
      if (!taskCalled) {
        timer.resume();
      }
    });
  }
};

export const sessionHasVcTimer = sessionId => timerMap.has(sessionId);

export const getVcTimerById = sessionId => timerMap.get(sessionId);

export const stopVcTimerById = sessionId => {
  const timer = getVcTimerById(sessionId);

  if (timer) {
    timer.stop();
  }
};

export const removeVcTimer = sessionId => timerMap.delete(sessionId);

export const pauseVcTimers = () => {
  if (vcTimersExist()) {
    timerMap.forEach(timer => {
      const { taskCalled } = timer.timerTaskCalled();
      if (!taskCalled) {
        timer.pause();
      }
    });
  }
};
